<template>
	<v-alert v-if="excludedDocuments.length" type="warning" variant="tonal" density="compact" class="mt-3">
		<div class="text-body-2 font-weight-medium">
			{{ excludedDocuments.length }} {{ excludedDocuments.length === 1 ? "document was" : "documents were" }} too large to include in this report.
		</div>
		<div class="text-body-2">
			These files were skipped so the report could still be generated. The rest of your content is included:
		</div>
		<div class="d-flex flex-wrap ga-1 mt-2">
			<v-chip v-for="(document, index) in excludedDocuments" :key="index" size="small" variant="tonal" color="warning">
				{{ documentLabel(document) }}
			</v-chip>
		</div>
	</v-alert>
</template>

<script setup lang="ts">
	import { type ExcludedDocument, formatExcludedDocumentSize } from "@/components/common/entity/sparkyReportTypes";

	defineProps<{ excludedDocuments: ExcludedDocument[] }>();

	// We deliberately omit the limit number from the copy above (it is env-overridable and would drift).
	function documentLabel(document: ExcludedDocument): string {
		// trim() so null/undefined/empty AND whitespace-only filenames all fall back to a readable label.
		const name = document.fileName?.trim() || "document";
		const size = formatExcludedDocumentSize(document.sizeBytes);
		return size ? `${name} · ${size}` : name;
	}
</script>
